import { RootState } from '../index';

export const userLanguage = (state: RootState) => state.user.language;

export const userInfo = (state: RootState) => state.user;
